export default "__VITE_ASSET__CF7O2ELi__"